import React from "react";

export default class BaseComponent extends React.Component {
  static watchedProps = [];

  componentDidUpdate(prevProps) {
    const checkPropHasChanged = (watchedProps, watchedPropCase = null) => {
      if (watchedProps.length && this.anyPropHasChanged(prevProps, watchedProps)) {
        this.onPropHasChanged(prevProps, watchedPropCase);
      }
    };

    const watchedProps = this.constructor.watchedProps;

    if (Array.isArray(watchedProps)) {
      checkPropHasChanged(watchedProps);
    } else if (typeof watchedProps === "object") {
      Object.keys(watchedProps).forEach(key => checkPropHasChanged(watchedProps[key], key));
    }
  }

  onPropHasChanged() { }

  anyPropHasChanged(prevProps, propNames) {
    return propNames.some(propName => this.props[propName] !== prevProps[propName]);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/lib/base-component.js